import { atom } from 'recoil';

export const defaultLang = atom({
    key: 'defaultLang',
    default: null,
});

export const languagesList = atom({
    key: 'languagesList',
    default: [],
});
